module.exports = __webpack_public_path__ + "46e679e7eaae46955d929a8a37c54102.png";